import $ from "jquery";

const linkifyTableRow = function (e) {
  if ($(e.target).closest("td").hasClass("col-actions")) { return; } // Do not intercept clicks on the col action btns.
  e.preventDefault();

  const $firstTd = $(this).find("td:first-child");
  const links = $firstTd.find("a");

  if (links.length > 0) {
    window.Navigation.goToLinkWithClick(links[0], true);
  }
};

const highlightRows = function () {
  $(".whole-row-link-table tbody tr:not(.highlight-bound)").each(function () {
    const $tr = $(this);
    const $firstTd = $tr.find("td:first-child");
    const historic = $firstTd.find(".psp-historic-tag").length > 0;
    if (historic) {
      $tr.addClass("historic-row").addClass("highlight-bound");
    }
  });
};

$(document).on("turbolinks:load", function () {
  $(document).on("click", ".whole-row-link-table tbody tr", linkifyTableRow);

  highlightRows();
});

$(document).on("draw.dt", highlightRows);
